import { DateSelectArg, EventInput, EventSourceFuncArg } from "@fullcalendar/core";
import DateFormatUtils from "../methods/date_formats";
import { RoleInfo } from "./user.model";
import dayjs from "dayjs";

export interface EventTimeInfo extends EventSourceFuncArg, DateSelectArg {}

export interface Event {
    id: string | number,
    event_type_id?: number,
    event_type_name?: string,
    location: string,
    description?: string,
    details?: {
        note: string,
        reminder: string,
    },
    started_at: string,
    ended_at: string,
    start_time: string, 
    end_time: string,
    all_day: boolean,
    patient_summary?: EventUserSummary,
    user_summary: EventUserSummary,
}

export interface EventUserSummary {
    firstname: string,
    lastname: string,
    id: string,
    role?: RoleInfo
}

export interface EventType {
    id: number,
    name: string,
    description: string,
}

export function eventFromTimeInfo(info: EventTimeInfo):Event {
    return {
        all_day: info.allDay,
        started_at: DateFormatUtils.YYYYMMDD(info.start),
        start_time: DateFormatUtils.HHmm(info.start),
        ended_at: DateFormatUtils.YYYYMMDD(info.end),
        end_time: DateFormatUtils.HHmm(info.end),
    } as Event
}

export function calendarInputFromEvent(event: Event):EventInput {
    return {
        allDay: event.all_day,
        start: DateFormatUtils.dateFromDayTime(event.started_at, event.start_time),
        end: DateFormatUtils.dateFromDayTime(event.ended_at, event.end_time),
        title: `${event.event_type_name}${event.patient_summary != null ?` - ${event.patient_summary.lastname} ${event.patient_summary.firstname}` : ''}`,
        extendedProps: event,
        display: 'block',
        id: `${event.id}`,
        groupId: `${event.patient_summary?.id}`,
    }
}

